export const columns = function () {
    return [
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 150,
            fixed: 'left'
        },
        {
            prop: 'vin',
            label: '车架号',
            minWidth: 200,
        },
        {
            prop: 'engineNo',
            label: '发动机号',
            minWidth: 200,
        },
        {
            prop: 'beginDate',
            label: '初登日期',
            minWidth: 200,
        },
        {
            prop: 'usetype',
            label: '使用性质',
            minWidth: 100,
        },
        {
            prop: 'carType',
            label: '车型',
            minWidth: 150,
        },
        {
            prop: 'brandType',
            label: '品牌型号',
            minWidth: 150,
        },
        {
            prop: 'passengerCount',
            label: '核定载客(人)',
            minWidth: 150,
        },
        {
            prop: 'loadWeight',
            label: '核定载质量(kg)',
            minWidth: 150,
        },
        {
            prop: 'handle',
            label: '操作',
            width: 150,
            fixed: 'right'
        }
    ]
}

export default {}